import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

/* Balão com o texto completo quando o rótulo está truncado (ellipsis). */
const TruncatedTooltip = ({ text = "", className = "", children }) => {
  const labelRef = useRef(null);
  const [truncated, setTruncated] = useState(false);
  const [tip, setTip] = useState(null); // { left, top, above }

  const measure = useCallback(() => {
    const el = labelRef.current;
    if (!el) return;
    setTruncated(el.scrollWidth > el.clientWidth + 1);
  }, []);

  useLayoutEffect(() => {
    measure();
  }, [text, measure]);

  useEffect(() => {
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [measure]);

  const showTip = () => {
    if (!truncated || !text) return;
    const el = labelRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const maxW = 320;
    let left = rect.left;
    let top = rect.bottom + 6;
    let above = false;

    if (left + maxW > window.innerWidth - 8) {
      left = Math.max(8, window.innerWidth - maxW - 8);
    }
    if (top + 60 > window.innerHeight - 8) {
      top = rect.top - 6;
      above = true;
    }

    setTip({ left, top, above });
  };

  const hideTip = () => setTip(null);

  return (
    <>
      <span
        ref={labelRef}
        className={className}
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
      >
        {children ?? text}
      </span>
      {tip &&
        truncated &&
        createPortal(
          <div
            className={`filter-label-tip${tip.above ? " above" : ""}`}
            style={{ left: tip.left, top: tip.top }}
            role="tooltip"
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};

export default TruncatedTooltip;
